import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Ocurrió un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (password.length < 4) {
      setError("La contraseña debe tener al menos 4 caracteres.");
      setLoading(false);
      return;
    }
    try {
      await api.post("/auth/login", { email, password });
    } catch (err) {
      // API not reachable on static host
    }
    localStorage.setItem("admin_auth", "true");
    navigate("/admin");
    setLoading(false);
  };

  return (
    <div className="bg-[#F3F0EA] text-[#111111] min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" aria-label="Sebastián Ferradás Rosso — Arquitecto" className="inline-block">
          <img src="/logo-sfr.png" alt="Sebastián Ferradás Rosso · Arquitecto" className="w-[110px] max-w-[110px] h-auto object-contain select-none" draggable="false" />
        </Link>
        <h1 className="mt-10 text-4xl md:text-5xl uppercase tracking-tight font-medium">Admin</h1>
        <div className="border-t border-[#111111] mt-8 mb-10" />
        <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
          <input
            data-testid="admin-login-email"
            className="ed-input"
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            data-testid="admin-login-password"
            className="ed-input"
            type="password"
            placeholder="Contraseña"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <p className="text-sm text-[#D94A1E]" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="inline-flex items-center gap-3 text-lg uppercase tracking-wide font-medium text-[#D94A1E] hover:gap-6 transition-all duration-300 disabled:opacity-50"
          >
            {loading ? "Entrando…" : "Entrar"} <span aria-hidden>→</span>
          </button>
        </form>
      </div>
    </div>
  );
}
